import styles from "./page-container.module.css"

export function PageContainer({
  children,
  page,
  ref
}: React.ComponentProps<"div"> & { page?: string }) {
  return (
    <div ref={ref} className={styles["container"]} data-page={page}>
      {children}
    </div>
  )
}
